import Axios from 'axios'

export default {
  searchCostCenter (query) {
    return Axios.get(`api/v1/cost-centers?term=${query}&amount=5`)
  }
}
